define.alias("shared/components/shared/post-tagging/tag-dropdown-item", "settings/components/shared/post-tagging/tag-dropdown-item");